import { Module } from '@nestjs/common';
import {UserEntity} from './user.entity';
import {TypeOrmModule} from '@nestjs/typeorm';
import { UserService } from './user.service';
import { UserToDivisionEntity } from './user-to-division.entity';

@Module({
  imports: 
    [TypeOrmModule.forFeature([UserEntity,UserToDivisionEntity])],
  providers: [UserService],
  exports: [UserService]
})
export class UserModule {}
